<template>





<div style="text-align: center; margin:auto; max-width:900px">
  <img
  src="public/images/site/faq.svg"
  id="challenges"
  alt="Miles de proyectos"
  style="width:100%; margin-top: 100px"
/>
  <div
  style="
  background-color: #ececec;
  padding-top: 50px;
  padding-bottom: 30px;
  margin-left: 20px;
  margin-right: 20px;"
  >

  <div style="padding:20px">
  <div role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-1 variant="info">
          ¿Que es Arkidia?
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Arkidia es una plataforma virtual de entretenimiento educativo para chicos de 6 a 13 años. Nuestra misión es estimular y potenciar el desarrollo de los niños y niñas, más allá de la escuela. Creemos que con la motivación correcta y las condiciones adecuadas siempre queremos aprender y compartir lo que aprendemos. 
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-2 variant="info">
          ¿Cómo funciona Arkidia?
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Te registras y registras a los niños y niñas que quieras (que nosotros llamamos Arkidians). Luego los Arkidians acceden a las actividades y comparten lo que aprendieron y crearon. Pueden hacer comentarios y dar likes a las creaciones de otros Arkidians.  
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>


<b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-5 variant="info">
          ¿Cuál es su costo?
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
Por el momento Arkidia está en etapa de pruebas. Su acceso se encuentra cerrado al público en general y es solamente por invitación. Si te interesa participar en el futuro envíanos un correo a quiero@arkidia.com.          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>


    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-3 variant="info">
          ¿Necesito comprar materiales?
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
           Para la mayoría de los cursos, no. Intentamos que los desafíos de Arkidia puedan realizarse con objetos disponibles en los hogares.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-4 variant="info">
         ¿Qué seguridad brinda Arkidia?
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
      Nos gusta divertirnos mientras aprendemos, pero nos tomamos la seguridad y privacidad muy en serio, ya que construimos Arkidia para que sea un ambiente completamente protegido:<br>
          </b-card-text>
           <b-card-text style="text-align:left">
      (1) Reforzamos el comportamiento positivo y constructivo en todas las interacciones de los Arkidians.<br>
      (2) Se requiere un login y el contenido no se accesible fuera de Arkidia.<br>
      (3) Los Arkidians deben utilizar apodos. <br>
      (4) Los comentarios y los desafíos que suben los Arkidians se aprueban antes de ser publicados.<br>
      (5) Guardamos un registro con toda la actividad de los usuarios.<br>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

  </div>


  </div>



</div>
  <img
  src="public/images/site/paint-grey.svg"
  id="challenges"
  alt="Miles de proyectos"
  style=" margin-left: 20px;
  margin-right: 20px;"
/>
</div>

 

</template>

<script>
import { mapGetters } from 'vuex'

  export default {
    
    name: 'app',

    data () {
      return {
        errorMessage:"",
        text:"hola",
        login:{
          usuario:"",
          password:""
          }
      }
    },

    computed:{
    ...mapGetters(['pathAPI','userLogged']),

    },

    methods:{
     
    },

    computed:{

    }
        ,
    components:{

    },

    mounted: function(){

    },


  }
</script>

<style scoped>

.btn-info {
    color: rgb(255, 255, 255);
    background-color: #34cee6;
    border: 0px;
    font-family: 'Patua One', cursive;
    padding:15px;
}

.card-body{
  padding:20px;
  margin: 20px;
  background: white;
  border-radius: 15px;
}

.p-1{
  padding:0px !important;
}


</style>


// WEBPACK FOOTER //
// src/components/startPage/Faq.vue